export const topsTypes = {
  COUNT: 'COUNT',
  REVENUE: 'REVENUE',
}

export const topsTypesLabels = {
  COUNT: 'dashboard.tops type count',
  REVENUE: 'dashboard.tops type revenue',
}
